// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* seriesView.module.css */
.SeriesView_container__wnrtw {
    min-height: 100vh;
    background-color: #000000;
    color: #ffffff;
  }
  
  .SeriesView_heroSection__BiGcb {
    position: relative;
    height: 400px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), #000000);
  }
  
  .SeriesView_heroBg__O\\+zxm {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
    z-index: -1;
    filter: grayscale(30%) brightness(0.7);
  }
  
  .SeriesView_heroContent__P1vLm {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 24px;
    height: 100%;
    display: flex;
    align-items: flex-end;
  }
  
  .SeriesView_heroInfo__l79hi {
    max-width: 800px;
  }
  
  .SeriesView_breadcrumb__G-Is\\+ {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #888888;
  }
  
  .SeriesView_breadcrumbLink__9Af7s {
    color: #ff0000;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: color 0.3s ease;
  }
  
  .SeriesView_breadcrumbLink__9Af7s:hover {
    color: #ff3333;
  }
  
  .SeriesView_title__OsOHs {
    font-size: 48px;
    font-weight: 800;
    margin-bottom: 20px;
    color: #ffffff;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
    line-height: 1.2;
  }
  
  .SeriesView_metaInfo__U6KHG {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 24px;
  }
  
  .SeriesView_metaItem__qJa8h {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #cccccc;
    font-size: 15px;
    background: rgba(255, 255, 255, 0.1);
    padding: 8px 16px;
    border-radius: 20px;
  }
  
  .SeriesView_statusBadge__8bKnO {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  
  .SeriesView_published__Dz9aw {
    background: linear-gradient(135deg, #00a86b, #008f5d);
    color: white;
  }
  
  .SeriesView_draft__d7voA {
    background: linear-gradient(135deg, #9333ea, #7e22ce);
    color: white;
  }
  
  .SeriesView_archived__SuufL {
    background: linear-gradient(135deg, #4b5563, #374151);
    color: white;
  }
  
  .SeriesView_mainContent__8qFPm {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 24px;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 40px;
  }
  
  .SeriesView_contentSection__GUuY0 {
    background: #111111;
    border-radius: 16px;
    padding: 32px;
    border: 1px solid #222222;
    margin-bottom: 24px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .SeriesView_contentSection__GUuY0:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255, 0, 0, 0.1);
  }
  
  .SeriesView_sectionTitle__1nxAr {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 24px;
    color: #ff0000;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .SeriesView_description__aYVBe {
    color: #dddddd;
    line-height: 1.8;
    margin-bottom: 32px;
    font-size: 16px;
  }
  
  .SeriesView_infoGrid__Q7s8A {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
  
  .SeriesView_infoItem__J\\+mJ7 {
    padding: 20px;
    background: #1a1a1a;
    border-radius: 12px;
    border: 1px solid #333333;
    transition: transform 0.3s ease;
  }
  
  .SeriesView_infoItem__J\\+mJ7:hover {
    transform: translateY(-2px);
    border-color: #ff0000;
  }
  
  .SeriesView_infoLabel__Db1DR {
    font-size: 14px;
    color: #888888;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  
  .SeriesView_infoValue__1LrGo {
    font-size: 16px;
    color: #ffffff;
    font-weight: 500;
  }
  
  .SeriesView_sidebar__o2O61 {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  .SeriesView_coverImage__FtLyE {
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 12px;
    border: 2px solid #222222;
    transition: transform 0.3s ease, border-color 0.3s ease;
  }
  
  .SeriesView_coverImage__FtLyE:hover {
    border-color: #ff0000;
    transform: scale(1.02);
  }
  
  .SeriesView_priceCard__55foo {
    background: #111111;
    border-radius: 16px;
    padding: 32px;
    border: 1px solid #222222;
    text-align: center;
  }
  
  .SeriesView_price__DF\\+xD {
    font-size: 48px;
    font-weight: 800;
    color: #ff0000;
    margin-bottom: 24px;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .SeriesView_button__ycyVa {
    width: 100%;
    padding: 16px 24px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    font-size: 16px;
  }
  
  .SeriesView_primaryButton__Axbtp {
    background: linear-gradient(135deg, #ff0000, #cc0000);
    color: white;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  .SeriesView_primaryButton__Axbtp:hover {
    background: linear-gradient(135deg, #cc0000, #990000);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);
  }
  
  .SeriesView_loading__wZW00 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;
    font-size: 18px;
    color: #ff0000;
    gap: 12px;
  }
  
  .SeriesView_spinner__xcYwL {
    animation: SeriesView_spin__qVGYP 1s linear infinite;
  }
  
  @keyframes SeriesView_spin__qVGYP {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  
  @media (max-width: 1024px) {
    .SeriesView_mainContent__8qFPm {
      grid-template-columns: 1fr;
    }
    
    .SeriesView_infoGrid__Q7s8A {
      grid-template-columns: 1fr;
    }
    
    .SeriesView_sidebar__o2O61 {
      order: -1;
    }
  }
  
  @media (max-width: 768px) {
    .SeriesView_heroSection__BiGcb {
      height: auto;
      min-height: 300px;
    }
    
    .SeriesView_title__OsOHs {
      font-size: 32px;
    }
    
    .SeriesView_metaInfo__U6KHG {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
    }
    
    .SeriesView_contentSection__GUuY0 {
      padding: 24px;
    }
    
    .SeriesView_price__DF\\+xD {
      font-size: 36px;
    }
  }
  
  @media (max-width: 480px) {
    .SeriesView_mainContent__8qFPm {
      padding: 24px 16px;
    }
    
    .SeriesView_metaItem__qJa8h {
      font-size: 14px;
      padding: 6px 12px;
    }
    
    .SeriesView_title__OsOHs {
      font-size: 28px;
    }
    .SeriesView_contentSection__GUuY0 {
      padding: 0px;
      width: 95%;
    }
    .SeriesView_coverImage__FtLyE {
      width: 95%;
    }
    .SeriesView_heroContent__P1vLm {
      padding-top: 5rem;
    }
  }
  /* Add these new styles to your existing SeriesView.module.css file */

/* Add these new styles to your existing SeriesView.module.css file */

.SeriesView_addChapterContainer__0FWCD {
  margin: 40px 0;
  display: flex;
  justify-content: center;
  width: 100%;
}

.SeriesView_addChapterButton__JC-vg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 48px;
  border: none;
  background-color: #000000;
  border-radius: 12px;
  cursor: pointer;
  color: #ffffff;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.SeriesView_addChapterButton__JC-vg span {
  margin-top: 12px;
  font-size: 18px;
  letter-spacing: 0.5px;
}

.SeriesView_addChapterButton__JC-vg svg {
  color: #ff3333;
  transition: transform 0.3s ease;
}

.SeriesView_addChapterButton__JC-vg:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  background-color: #111111;
}

.SeriesView_addChapterButton__JC-vg:hover svg {
  transform: scale(1.1);
  color: #ff4d4d;
}

/* Full screen overlay styles */
.SeriesView_fullScreenOverlay__a68kp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: SeriesView_fadeIn__\\+JP2G 0.3s ease-out;
}

@keyframes SeriesView_fadeIn__\\+JP2G {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.SeriesView_overlayContent__NCEJY {
  width: 90%;
  height: 90%;
  background-color: #121212;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #333;
  animation: SeriesView_scaleIn__Qp74X 0.3s ease-out;
}

@keyframes SeriesView_scaleIn__Qp74X {
  from {
    transform: scale(0.95);
  }
  to {
    transform: scale(1);
  }
}

.SeriesView_overlayHeader__UXFVF {
  background-color: #000000;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #ff3333;
}

.SeriesView_overlayHeader__UXFVF h2 {
  color: #ff3333;
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.SeriesView_closeButton__3ilCV {
  background: transparent;
  border: none;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.SeriesView_closeButton__3ilCV:hover {
  background-color: rgba(255, 51, 51, 0.2);
  color: #ff3333;
}

.SeriesView_overlayBody__dXRIT {
  flex: 1 1;
  padding: 32px;
  overflow-y: auto;
  color: #ffffff;
}

.SeriesView_formPlaceholder__6ZdDd {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999999;
  text-align: center;
}

.SeriesView_formPlaceholder__6ZdDd svg {
  color: #ff3333;
  margin-bottom: 24px;
  opacity: 0.8;
}

.SeriesView_formPlaceholder__6ZdDd p {
  font-size: 18px;
  margin: 0;
}
.SeriesView_chaptersList__6Iz-Y {
  margin-top: 20px;
}

.SeriesView_chapterCard__wnq3c {
  display: flex;
  margin-bottom: 20px;
  background: #121212;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  border: 1px solid #2a2a2a;
}

.SeriesView_chapterImageContainer__v8wt- {
  position: relative;
  width: 160px;
  min-width: 160px;
}

.SeriesView_chapterImage__DSMXW {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.SeriesView_playButton__2wZkP {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: #e63946;
  border: none;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
}

.SeriesView_playButton__2wZkP:hover {
  background: rgba(0, 0, 0, 0.9);
  color: #ff4d5e;
}

.SeriesView_chapterInfo__WYfUF {
  padding: 16px;
  flex: 1 1;
  color: #e6e6e6;
}

.SeriesView_chapterHeader__MAS7y {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.SeriesView_chapterTitle__MaM48 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #ffffff;
}

.SeriesView_chapterControls__AM3lU {
  display: flex;
  gap: 8px;
}

.SeriesView_iconButton__Ay1c7 {
  background: none;
  border: none;
  cursor: pointer;
  color: #a0a0a0;
  transition: color 0.2s;
}

.SeriesView_iconButton__Ay1c7:hover {
  color: #e63946;
}

.SeriesView_chapterDescription__WSa3M {
  margin: 8px 0;
  color: #b0b0b0;
}

.SeriesView_chapterMeta__eKFc- {
  font-size: 14px;
  color: #909090;
  margin-bottom: 12px;
}

.SeriesView_chapterStats__Znm8X {
  display: flex;
  gap: 16px;
}

.SeriesView_metaItem__qJa8h {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #a0a0a0;
}

.SeriesView_emptyState__ymf6R {
  padding: 20px;
  text-align: center;
  background: #1a1a1a;
  border-radius: 8px;
  color: #909090;
  border: 1px dashed #2a2a2a;
}
/* Add these styles to your SeriesView.module.css file */

.SeriesView_confirmationText__z\\+e02 {
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.5;
  color: white;
}

.SeriesView_confirmationActions__8dgsg {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.SeriesView_actionButton__YOM\\+O {
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.SeriesView_actionButton__YOM\\+O:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.SeriesView_cancelButton__s0ezE {
  background-color: #f2f2f2;
  color: #333;
  border: 1px solid #ddd;
}

.SeriesView_cancelButton__s0ezE:hover:not(:disabled) {
  background-color: #e6e6e6;
}

.SeriesView_deleteButton__I9VCP {
  background-color: #f44336;
  color: white;
  border: 1px solid #f44336;
}

.SeriesView_deleteButton__I9VCP:hover:not(:disabled) {
  background-color: #d32f2f;
}
.SeriesView_midScreenOverlay__TeHA-{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: SeriesView_fadeIn__\\+JP2G 0.3s ease-out; 
}

.SeriesView_midoverlayContent__p0bHd{
  width: 90%;
  height: auto;
  background-color: #121212;
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #333;
  animation: SeriesView_scaleIn__Qp74X 0.3s ease-out;
}`, "",{"version":3,"sources":["webpack://./src/admin/pages/Series/SeriesView.module.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mEAAmE;EACrE;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,2CAA2C;IAC3C,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,qDAAqD;IACrD,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;EACjC;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,uDAAuD;EACzD;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,qDAAqD;IACrD,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,qDAAqD;IACrD,2BAA2B;IAC3B,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,SAAS;EACX;;EAEA;IACE,oDAAkC;EACpC;;EAEA;IACE,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;EAClC;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,SAAS;IACX;EACF;;EAEA;IACE;MACE,YAAY;MACZ,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,uBAAuB;MACvB,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,UAAU;IACZ;IACA;MACE,UAAU;IACZ;IACA;MACE,iBAAiB;IACnB;EACF;EACA,qEAAqE;;AAEvE,qEAAqE;;AAErE;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kDAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kDAAgC;AAClC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;AACA,wDAAwD;;AAExD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kDAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,kDAAgC;AAClC","sourcesContent":["/* seriesView.module.css */\n.container {\n    min-height: 100vh;\n    background-color: #000000;\n    color: #ffffff;\n  }\n  \n  .heroSection {\n    position: relative;\n    height: 400px;\n    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), #000000);\n  }\n  \n  .heroBg {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    opacity: 0.3;\n    z-index: -1;\n    filter: grayscale(30%) brightness(0.7);\n  }\n  \n  .heroContent {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 24px;\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n  }\n  \n  .heroInfo {\n    max-width: 800px;\n  }\n  \n  .breadcrumb {\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #888888;\n  }\n  \n  .breadcrumbLink {\n    color: #ff0000;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    transition: color 0.3s ease;\n  }\n  \n  .breadcrumbLink:hover {\n    color: #ff3333;\n  }\n  \n  .title {\n    font-size: 48px;\n    font-weight: 800;\n    margin-bottom: 20px;\n    color: #ffffff;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n    line-height: 1.2;\n  }\n  \n  .metaInfo {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 24px;\n  }\n  \n  .metaItem {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #cccccc;\n    font-size: 15px;\n    background: rgba(255, 255, 255, 0.1);\n    padding: 8px 16px;\n    border-radius: 20px;\n  }\n  \n  .statusBadge {\n    padding: 8px 16px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: 600;\n    text-transform: capitalize;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n  }\n  \n  .published {\n    background: linear-gradient(135deg, #00a86b, #008f5d);\n    color: white;\n  }\n  \n  .draft {\n    background: linear-gradient(135deg, #9333ea, #7e22ce);\n    color: white;\n  }\n  \n  .archived {\n    background: linear-gradient(135deg, #4b5563, #374151);\n    color: white;\n  }\n  \n  .mainContent {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 24px;\n    display: grid;\n    grid-template-columns: 2fr 1fr;\n    gap: 40px;\n  }\n  \n  .contentSection {\n    background: #111111;\n    border-radius: 16px;\n    padding: 32px;\n    border: 1px solid #222222;\n    margin-bottom: 24px;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .contentSection:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 24px rgba(255, 0, 0, 0.1);\n  }\n  \n  .sectionTitle {\n    font-size: 24px;\n    font-weight: 700;\n    margin-bottom: 24px;\n    color: #ff0000;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .description {\n    color: #dddddd;\n    line-height: 1.8;\n    margin-bottom: 32px;\n    font-size: 16px;\n  }\n  \n  .infoGrid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 24px;\n  }\n  \n  .infoItem {\n    padding: 20px;\n    background: #1a1a1a;\n    border-radius: 12px;\n    border: 1px solid #333333;\n    transition: transform 0.3s ease;\n  }\n  \n  .infoItem:hover {\n    transform: translateY(-2px);\n    border-color: #ff0000;\n  }\n  \n  .infoLabel {\n    font-size: 14px;\n    color: #888888;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  \n  .infoValue {\n    font-size: 16px;\n    color: #ffffff;\n    font-weight: 500;\n  }\n  \n  .sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n  \n  .coverImage {\n    width: 100%;\n    aspect-ratio: 16/9;\n    object-fit: cover;\n    border-radius: 12px;\n    border: 2px solid #222222;\n    transition: transform 0.3s ease, border-color 0.3s ease;\n  }\n  \n  .coverImage:hover {\n    border-color: #ff0000;\n    transform: scale(1.02);\n  }\n  \n  .priceCard {\n    background: #111111;\n    border-radius: 16px;\n    padding: 32px;\n    border: 1px solid #222222;\n    text-align: center;\n  }\n  \n  .price {\n    font-size: 48px;\n    font-weight: 800;\n    color: #ff0000;\n    margin-bottom: 24px;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n  }\n  \n  .button {\n    width: 100%;\n    padding: 16px 24px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    font-size: 16px;\n  }\n  \n  .primaryButton {\n    background: linear-gradient(135deg, #ff0000, #cc0000);\n    color: white;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n  }\n  \n  .primaryButton:hover {\n    background: linear-gradient(135deg, #cc0000, #990000);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(255, 0, 0, 0.3);\n  }\n  \n  .loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 400px;\n    font-size: 18px;\n    color: #ff0000;\n    gap: 12px;\n  }\n  \n  .spinner {\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n  }\n  \n  @media (max-width: 1024px) {\n    .mainContent {\n      grid-template-columns: 1fr;\n    }\n    \n    .infoGrid {\n      grid-template-columns: 1fr;\n    }\n    \n    .sidebar {\n      order: -1;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .heroSection {\n      height: auto;\n      min-height: 300px;\n    }\n    \n    .title {\n      font-size: 32px;\n    }\n    \n    .metaInfo {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 12px;\n    }\n    \n    .contentSection {\n      padding: 24px;\n    }\n    \n    .price {\n      font-size: 36px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .mainContent {\n      padding: 24px 16px;\n    }\n    \n    .metaItem {\n      font-size: 14px;\n      padding: 6px 12px;\n    }\n    \n    .title {\n      font-size: 28px;\n    }\n    .contentSection {\n      padding: 0px;\n      width: 95%;\n    }\n    .coverImage {\n      width: 95%;\n    }\n    .heroContent {\n      padding-top: 5rem;\n    }\n  }\n  /* Add these new styles to your existing SeriesView.module.css file */\n\n/* Add these new styles to your existing SeriesView.module.css file */\n\n.addChapterContainer {\n  margin: 40px 0;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.addChapterButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 48px;\n  border: none;\n  background-color: #000000;\n  border-radius: 12px;\n  cursor: pointer;\n  color: #ffffff;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.addChapterButton span {\n  margin-top: 12px;\n  font-size: 18px;\n  letter-spacing: 0.5px;\n}\n\n.addChapterButton svg {\n  color: #ff3333;\n  transition: transform 0.3s ease;\n}\n\n.addChapterButton:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n  background-color: #111111;\n}\n\n.addChapterButton:hover svg {\n  transform: scale(1.1);\n  color: #ff4d4d;\n}\n\n/* Full screen overlay styles */\n.fullScreenOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.overlayContent {\n  width: 90%;\n  height: 90%;\n  background-color: #121212;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #333;\n  animation: scaleIn 0.3s ease-out;\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n.overlayHeader {\n  background-color: #000000;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #ff3333;\n}\n\n.overlayHeader h2 {\n  color: #ff3333;\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.closeButton {\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.closeButton:hover {\n  background-color: rgba(255, 51, 51, 0.2);\n  color: #ff3333;\n}\n\n.overlayBody {\n  flex: 1;\n  padding: 32px;\n  overflow-y: auto;\n  color: #ffffff;\n}\n\n.formPlaceholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #999999;\n  text-align: center;\n}\n\n.formPlaceholder svg {\n  color: #ff3333;\n  margin-bottom: 24px;\n  opacity: 0.8;\n}\n\n.formPlaceholder p {\n  font-size: 18px;\n  margin: 0;\n}\n.chaptersList {\n  margin-top: 20px;\n}\n\n.chapterCard {\n  display: flex;\n  margin-bottom: 20px;\n  background: #121212;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);\n  border: 1px solid #2a2a2a;\n}\n\n.chapterImageContainer {\n  position: relative;\n  width: 160px;\n  min-width: 160px;\n}\n\n.chapterImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.7);\n  color: #e63946;\n  border: none;\n  border-radius: 50%;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.playButton:hover {\n  background: rgba(0, 0, 0, 0.9);\n  color: #ff4d5e;\n}\n\n.chapterInfo {\n  padding: 16px;\n  flex: 1;\n  color: #e6e6e6;\n}\n\n.chapterHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.chapterTitle {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0;\n  color: #ffffff;\n}\n\n.chapterControls {\n  display: flex;\n  gap: 8px;\n}\n\n.iconButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #a0a0a0;\n  transition: color 0.2s;\n}\n\n.iconButton:hover {\n  color: #e63946;\n}\n\n.chapterDescription {\n  margin: 8px 0;\n  color: #b0b0b0;\n}\n\n.chapterMeta {\n  font-size: 14px;\n  color: #909090;\n  margin-bottom: 12px;\n}\n\n.chapterStats {\n  display: flex;\n  gap: 16px;\n}\n\n.metaItem {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: #a0a0a0;\n}\n\n.emptyState {\n  padding: 20px;\n  text-align: center;\n  background: #1a1a1a;\n  border-radius: 8px;\n  color: #909090;\n  border: 1px dashed #2a2a2a;\n}\n/* Add these styles to your SeriesView.module.css file */\n\n.confirmationText {\n  margin-bottom: 24px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: white;\n}\n\n.confirmationActions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.actionButton {\n  padding: 8px 16px;\n  border-radius: 4px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.actionButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.cancelButton {\n  background-color: #f2f2f2;\n  color: #333;\n  border: 1px solid #ddd;\n}\n\n.cancelButton:hover:not(:disabled) {\n  background-color: #e6e6e6;\n}\n\n.deleteButton {\n  background-color: #f44336;\n  color: white;\n  border: 1px solid #f44336;\n}\n\n.deleteButton:hover:not(:disabled) {\n  background-color: #d32f2f;\n}\n.midScreenOverlay{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.9);\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  animation: fadeIn 0.3s ease-out; \n}\n\n.midoverlayContent{\n  width: 90%;\n  height: auto;\n  background-color: #121212;\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border: 1px solid #333;\n  animation: scaleIn 0.3s ease-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SeriesView_container__wnrtw`,
	"heroSection": `SeriesView_heroSection__BiGcb`,
	"heroBg": `SeriesView_heroBg__O+zxm`,
	"heroContent": `SeriesView_heroContent__P1vLm`,
	"heroInfo": `SeriesView_heroInfo__l79hi`,
	"breadcrumb": `SeriesView_breadcrumb__G-Is+`,
	"breadcrumbLink": `SeriesView_breadcrumbLink__9Af7s`,
	"title": `SeriesView_title__OsOHs`,
	"metaInfo": `SeriesView_metaInfo__U6KHG`,
	"metaItem": `SeriesView_metaItem__qJa8h`,
	"statusBadge": `SeriesView_statusBadge__8bKnO`,
	"published": `SeriesView_published__Dz9aw`,
	"draft": `SeriesView_draft__d7voA`,
	"archived": `SeriesView_archived__SuufL`,
	"mainContent": `SeriesView_mainContent__8qFPm`,
	"contentSection": `SeriesView_contentSection__GUuY0`,
	"sectionTitle": `SeriesView_sectionTitle__1nxAr`,
	"description": `SeriesView_description__aYVBe`,
	"infoGrid": `SeriesView_infoGrid__Q7s8A`,
	"infoItem": `SeriesView_infoItem__J+mJ7`,
	"infoLabel": `SeriesView_infoLabel__Db1DR`,
	"infoValue": `SeriesView_infoValue__1LrGo`,
	"sidebar": `SeriesView_sidebar__o2O61`,
	"coverImage": `SeriesView_coverImage__FtLyE`,
	"priceCard": `SeriesView_priceCard__55foo`,
	"price": `SeriesView_price__DF+xD`,
	"button": `SeriesView_button__ycyVa`,
	"primaryButton": `SeriesView_primaryButton__Axbtp`,
	"loading": `SeriesView_loading__wZW00`,
	"spinner": `SeriesView_spinner__xcYwL`,
	"spin": `SeriesView_spin__qVGYP`,
	"addChapterContainer": `SeriesView_addChapterContainer__0FWCD`,
	"addChapterButton": `SeriesView_addChapterButton__JC-vg`,
	"fullScreenOverlay": `SeriesView_fullScreenOverlay__a68kp`,
	"fadeIn": `SeriesView_fadeIn__+JP2G`,
	"overlayContent": `SeriesView_overlayContent__NCEJY`,
	"scaleIn": `SeriesView_scaleIn__Qp74X`,
	"overlayHeader": `SeriesView_overlayHeader__UXFVF`,
	"closeButton": `SeriesView_closeButton__3ilCV`,
	"overlayBody": `SeriesView_overlayBody__dXRIT`,
	"formPlaceholder": `SeriesView_formPlaceholder__6ZdDd`,
	"chaptersList": `SeriesView_chaptersList__6Iz-Y`,
	"chapterCard": `SeriesView_chapterCard__wnq3c`,
	"chapterImageContainer": `SeriesView_chapterImageContainer__v8wt-`,
	"chapterImage": `SeriesView_chapterImage__DSMXW`,
	"playButton": `SeriesView_playButton__2wZkP`,
	"chapterInfo": `SeriesView_chapterInfo__WYfUF`,
	"chapterHeader": `SeriesView_chapterHeader__MAS7y`,
	"chapterTitle": `SeriesView_chapterTitle__MaM48`,
	"chapterControls": `SeriesView_chapterControls__AM3lU`,
	"iconButton": `SeriesView_iconButton__Ay1c7`,
	"chapterDescription": `SeriesView_chapterDescription__WSa3M`,
	"chapterMeta": `SeriesView_chapterMeta__eKFc-`,
	"chapterStats": `SeriesView_chapterStats__Znm8X`,
	"emptyState": `SeriesView_emptyState__ymf6R`,
	"confirmationText": `SeriesView_confirmationText__z+e02`,
	"confirmationActions": `SeriesView_confirmationActions__8dgsg`,
	"actionButton": `SeriesView_actionButton__YOM+O`,
	"cancelButton": `SeriesView_cancelButton__s0ezE`,
	"deleteButton": `SeriesView_deleteButton__I9VCP`,
	"midScreenOverlay": `SeriesView_midScreenOverlay__TeHA-`,
	"midoverlayContent": `SeriesView_midoverlayContent__p0bHd`
};
export default ___CSS_LOADER_EXPORT___;
